<i18n
  src="@/locales/views/agro_exporter/production/basic_container_export/show_process.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <div class="mt-6">
    <h1 class="page-title">
      <i class="fa-solid fa-calendar-days"></i><span class="space-icon"></span
      >{{ $t("labels.schedule_title") }}
    </h1>
    <bimonthly-schedule :exportations="exportations" :containers="containers" />
  </div>
</template>

<script>
import ShowProcessTabsMixin from "@/components/views/agro_exporter/production/basic_container_export/show_process/show_process_tabs_mixin.js";
import BimonthlySchedule from "@/components/views/agro_exporter/production/shared/BimonthlySchedule.vue";

export default {
  name: "ShowProcessSchedule",
  mixins: [ShowProcessTabsMixin],
  components: { BimonthlySchedule },
  props: {
    containers: {
      type: Array,
      required: true,
    },
    exportations: {
      type: Array,
      required: true,
    },
  },
};
</script>
